import { can } from './can.js';
/**
 * Filtr menu polozek podle obou os (entitlements x role).
 * Zachovava poradi i konkretni typ polozek (T), aby produkty mohly
 * nest vlastni pole (label, path, icon…).
 */
export function filterMenu(items, user, policy) {
    return items.filter((item) => can(user, item.action, item.module, policy));
}
//# sourceMappingURL=menu.js.map